import React from 'react';
import Button from '@atlaskit/button';
import { useSidebar } from '@css-xp/base';
import { ADVOCATE_ACCESS_TYPE, ADVOCATE_RESOURCE_TYPE, AdvocateAccessWall } from '@css-xp/ppc-access-control';
import SIDEBAR from '../../../constants/sidebar';
import './header-actions.scss';
import { getPartnerServiceDeskUrlForGenericHelp } from '@css-xp/ppc-navigation';

export const HeaderActions = ({
  transactionAccountId,
  hideNewCustomerAction = false,
}: {
  transactionAccountId: string;
  hideNewCustomerAction?: boolean;
}) => {
  const { openSidebar } = useSidebar();

  const onAtlassianSupportClick = () => {
    window.open(getPartnerServiceDeskUrlForGenericHelp(), '_black', 'noopener');
  };

  const onNewCustomerClick = () => {
    openSidebar({
      sidebarType: SIDEBAR.ADD_CUSTOMER,
      payload: {
        transactionAccountId: transactionAccountId,
        hideAddFromBillToAddress: true,
        contentString: {
          HEADING: 'Add customer',
          SUBMIT_BUTTON: 'Add customer',
          NOTIFICATION_SUCCESS_HEADING: 'Customer added',
        },
      },
      sidebarOptions: {
        isOverlay: true,
        sidebarWidth: '600px',
      },
    });
  };

  return (
    <div className="home-header-actions">
      {!hideNewCustomerAction && (
        <AdvocateAccessWall accessType={ADVOCATE_ACCESS_TYPE.CREATE} resource={ADVOCATE_RESOURCE_TYPE.CUSTOMER}>
          <Button className="ml-16" onClick={onNewCustomerClick}>
            + New customer
          </Button>
        </AdvocateAccessWall>
      )}
      <Button className="ml-16" onClick={onAtlassianSupportClick}>
        Partner Service Desk
      </Button>
    </div>
  );
};
